﻿import { IMenuItem, isPopupMenuItem, MenuItemType } from "./menuItemBase";
import { PopupMenu } from "./popupMenu";
import { Key } from "ts-keycode-enum";


export class PopupMenuItem implements IMenuItem {
    public type: MenuItemType = "PopupMenuItem";
    public domNode: HTMLElement;
    public menu: PopupMenu;
    public hasFocus: boolean = false;
    public hasHover: boolean = false;
    private childPopupMenu?:  PopupMenu;

    private handleKeydown(event: KeyboardEvent) {
        let tgt: EventTarget | null = event.target;
        let flag: boolean = false;

        //? event.keyCode is depreciated but required for IE11 support
        switch (event.keyCode) {
            case Key.Space:
            case Key.Enter:
                // Create simulated mouse event to mimic the behavior of ATs
                // and let the event handler handleClick do the housekeeping.
                let clickEvent: MouseEvent | null = null;
                try {
                    clickEvent = new MouseEvent("click", {
                        view: window,
                        bubbles: true,
                        cancelable: true,
                    });
                } catch (err) {
                    if (document.createEvent) {
                        // DOM Level 3 for IE 9+
                        clickEvent = document.createEvent("MouseEvents");
                        clickEvent.initEvent("click", true, true);
                    }
                }
                if (tgt && clickEvent) {
                    tgt.dispatchEvent(clickEvent);
                }

                flag = true;
                break;

            case Key.DownArrow:

                this.menu.SetFocusToNextItem(this);
                flag = true;
                break;

            case Key.LeftArrow:

                if (isPopupMenuItem(this.menu.parent)){
                    this.menu.SetFocusToItem(this.menu.parent);
                    this.menu.Close(true);
                } else {
                    this.menu.SetFocusToController("previous");
                    this.menu.Close(true);
                }
                flag = true;

                break;

            case Key.RightArrow:
                if (this.childPopupMenu){
                    this.childPopupMenu.hasFocus = true;
                    this.childPopupMenu.Open()
                    this.childPopupMenu.SetFocusToFirstItem()
                    this.menu.hasFocus = true;
                    this.menu.hasHover = true;

                } else {
                    this.menu.SetFocusToController("next");
                    this.menu.Close(true);
                }
                flag = true;

                break;

            case Key.UpArrow:

                this.menu.SetFocusToPreviousItem(this);
                flag = true;
                break;

            case Key.Home:
            case Key.PageUp:

                this.menu.SetFocusToFirstItem();
                flag = true;

                break;

            case Key.End:
            case Key.PageDown:

                this.menu.SetFocusToLastItem();
                flag = true;
                break;

            case Key.Tab:
                this.menu.Close(true);
                break;

            case Key.Escape:
                this.menu.SetFocusToController("");
                this.menu.Close(true);
                flag = true;
                break;

            default:
                break;
        }
        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    private handleFocus() {
        this.menu.hasFocus = true;
        this.childPopupMenu?.Open()
    }

    private handleBlur() {
        this.menu.hasFocus = false;
        if (!this.childPopupMenu?.hasFocus && this.childPopupMenu){
            setTimeout(this.childPopupMenu.Close.bind(this.childPopupMenu, true), 100);
        } else {
            setTimeout(this.menu.Close.bind(this.menu, false), 400);
        }
    }

    private handleMouseover() {
        this.menu.hasHover = true;
        this.menu.Open();
        this.childPopupMenu?.Open();
    }

    public SetExpanded(value: boolean) {
        if (value) {
            this.domNode.setAttribute("aria-expanded", "true");
        } else {
            this.domNode.setAttribute("aria-expanded", "false");
        }
    }

    private handleMouseout() {
        this.menu.hasHover = false;
        setTimeout(this.menu.Close.bind(this.menu, false), 400);
        this.childPopupMenu?.Close(true)
    }

    constructor(domNode: HTMLElement, parent: PopupMenu) {
        this.domNode = domNode;
        this.menu = parent;
        this.domNode.tabIndex = -1;

        this.domNode.addEventListener("keydown", this.handleKeydown.bind(this));
        this.domNode.addEventListener("focus", this.handleFocus.bind(this));
        this.domNode.addEventListener("blur", this.handleBlur.bind(this));
        this.domNode.addEventListener(
            "mouseover",
            this.handleMouseover.bind(this)
        );
        this.domNode.addEventListener(
            "mouseout",
            this.handleMouseout.bind(this)
        );


        //Initialise the flyout menu

        const nextElement = domNode.nextElementSibling as HTMLElement;
        const menuItemHasChildren = nextElement?.tagName === "UL";

        if (menuItemHasChildren) {
            this.childPopupMenu =  new PopupMenu(nextElement, this, "Horizontal")
        }
    }

}
